import Vue from 'vue'
import Router from 'vue-router'
import TopPage from '../components/TopPage'
import DetailPage from '../components/DetailPage'
import CarrierEmailSettings from '../components/CarrierEmailSettings'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'top',
            component: TopPage,
        },

        {
            path: '/detail/:index',
            name: 'detail',
            props: true,
            component: DetailPage,
        },

        {
            path: '/page/carrier-email-settings',
            name: 'carrier-email-settings',
            component: CarrierEmailSettings
        }

    ],
})



// WEBPACK FOOTER //
// ./src/router/index.js